<template>
  <div class="wrapper">
    <div class="item" v-for="(i,index) in jsonList" :key="index">{{index}}. {{i}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jsonList: []
    };
  },
  mounted() {
    // this.$api.login.getEntryExitRecord().then(res => {
    //   console.log(res.data);
    //   if (res.data.code == 200) {
    //   }
    // });
    setInterval(() => {
      this.test();
    }, 1500);
  },
  methods: {
    test() {
      this.$api.parkinglot.test1().then(res => {
        console.log("南进口：" + JSON.stringify(res.data));
        if (JSON.stringify(res.data).indexOf("ok") != -1) {
          this.jsonList.push("南进口：" + JSON.stringify(res.data));
        }
      });
      this.$api.parkinglot.test2().then(res => {
        console.log("南出口：" + JSON.stringify(res.data));
        if (JSON.stringify(res.data).indexOf("ok") != -1) {
          this.jsonList.push("南出口：" + JSON.stringify(res.data));
        }
      });
      // this.$api.parkinglot.test3().then(res => {
      //   console.log("北进口：" + JSON.stringify(res.data));
      //   if (JSON.stringify(res.data).indexOf("ok") != -1) {
      //     this.jsonList.push("北进口：" + JSON.stringify(res.data));
      //   }
      // });
      // this.$api.parkinglot.test4().then(res => {
      //   console.log("北出口：" + JSON.stringify(res.data));
      //   if (JSON.stringify(res.data).indexOf("ok") != -1) {
      //     this.jsonList.push("北出口：" + JSON.stringify(res.data));
      //   }
      // });
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped>
@import '~common/stylus/variable';
@import '~common/stylus/mixin';

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: scroll;

  .item {
    margin-top: 12px;
  }
}
</style>
